import React from 'react';
import close from '../../../assets/icons/close.png'

function MModal({ active, setActive, children, onCloseModal = () => {}, ...props }) {

    const onClose = () => {
        onCloseModal();
        setActive(false)
    }

    return (
        <div
            className={`${!active && 'hidden'} w-[100vw] h-[100vh] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex justify-center items-center z-50`}
        >

            <div
                className={`p-8 rounded-xl bg-white relative ${props.className}`}
                onClick={e => e.stopPropagation()}
            >
                <img src={close} className="absolute top-3 right-3 hover:cursor-pointer" onClick={onClose} alt="close"/>
                {children}
            </div>
        </div>
    );
}

export default MModal;
